
export enum LogType {
    Login = 1,
    Nav = 2,
    Open = 3,
    Click = 4,
    Logout = 6
}
